import React, { useState, useEffect } from "react";
import Page from "../../../components/Page";
import { withTranslation } from "react-i18next";
import InputField from "../../../components/inputField";
import { Flex, Select, Text } from "@mantine/core";
import "./styles.css";
import { Dropzone, MIME_TYPES } from "@mantine/dropzone";
import { backendUrl } from "../../../constants";
import { showNotification } from "@mantine/notifications";

const Index = ({ profileVideo, setProfileVideo }) => {
  const [privacyLevels, setPrivacyLevels] = useState([]);
  const [files, setFiles] = useState([]);
  const [videoType, setVideoType] = useState("upload");

  //privacy Levels
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/privacyLevel`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setPrivacyLevels((p) => [...p, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className="location-main">
        <h2 className="text-dark text-center">Profile Video</h2>

        <Flex justify={"space-between"} className="mb-2">
          <Select
            defaultValue={"upload"}
            value={videoType}
            label="Select Video Type"
            data={[
              { label: "Upload Video", value: "upload" },
              { label: "Add URL", value: "link" },
            ]}
            style={{ width: "200px" }}
            maxDropdownHeight={400}
            onChange={(v) => setVideoType(v)}
          />
          <Select
            value={profileVideo.privacyLevel}
            label="Select Privacy Level"
            data={privacyLevels}
            placeholder="Privacy Level"
            style={{ width: "200px" }}
            maxDropdownHeight={400}
            onChange={(v) =>
              setProfileVideo((profileVideo) => ({
                ...profileVideo,
                privacyLevel: v,
              }))
            }
          />
        </Flex>
        <p style={{ margin: "0px", fontWeight: "500", fontSize: "12px" }}>
          ADD LINK FROM VIMEO OR YOUTUBE
        </p>

        {videoType === "link" ? (
          <>
            <InputField
              placeholder={"Paste video link here..."}
              icon="vimeo"
              style={{ border: "1px solid rgb(0,0,0,0.1)" }}
              value={profileVideo?.profileVideo}
              onBlur={(v) => {
                if (v.target.value.includes("youtube")) {
                  v.target.value = v.target.value.replace("watch?v=", "embed/");
                } else if (v.target.value.includes("vimeo")) {
                  v.target.value = v.target.value.replace(
                    "vimeo.com/",
                    "player.vimeo.com/video/"
                  );
                } else {
                  v.target.value = "";
                  showNotification({
                    title: "Invalid Link. ",
                    message: "Please enter a valid link. Youtube or Vimeo Only",
                    color: "red",
                  });
                }

                setFiles(v);
                setProfileVideo((profileVideo) => ({
                  ...profileVideo,
                  profileVideo: v.target.value,
                }));
              }}
            ></InputField>

            {profileVideo?.profileVideo && (
              <iframe
                className="utube"
                src={profileVideo?.profileVideo}
                title="video"
                width={"100%"}
                height="300px"
              ></iframe>
            )}
          </>
        ) : (
          <div>
            <video
              src={
                files.length
                  ? URL.createObjectURL(files[0])
                  : profileVideo.profileVideo
              }
              width="100%"
              height="300"
              controls
              className="p-video"
            />
            <Dropzone
              accept={MIME_TYPES.video}
              multiple={false}
              maxFiles={1}
              style={{ backgroundColor: "rgb(0,0,0, 0.1)" }}
              value={profileVideo.profileVideo}
              onDrop={(v) => {
                setFiles(v);
                setProfileVideo((profileVideo) => ({
                  ...profileVideo,
                  profileVideo: v[0],
                }));
              }}
            >
              <Text align="center" className="upload-video-text">
                Upload Profile Video
              </Text>
            </Dropzone>
          </div>
        )}
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
